import Vue from 'vue';
//import './brand/structure.module.scss';
//import './brand/typography.module.scss';
import VueAnalytics, { onAnalyticsReady } from 'vue-analytics';
import App from './layout/App.vue';

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-119414663-1',
});

const app = new Vue({
  render: (h) => h(App),
});
onAnalyticsReady().then(() => {
  app.$mount('#app');
});
